import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import FailedImageLogsService from "../../app/data/documents/failedImageLogsService";
import { initialFailedImageLogsState } from "./failedImageLogsState";
import { FailedImageLogsFilterModel } from "../../app/data/documents/failedImageLogsModels";

const failedImageLogsService = FailedImageLogsService.getInstance();

export const failedImageLogsSlice = createSlice({
  name: "failedImageLogs",
  initialState: initialFailedImageLogsState,
  reducers: {
    requestStarted: (state, { payload }) => {
      state.requestStarted = true;
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestError = "";
      state.requestCreator = payload;
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.requestSucceed = true;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestError = payload;
    },
    resetErrors: (state) => {
      state.requestFailed = false;
      state.requestError = "";
    },
    setRecordsRequest: (state, { payload }) => {
      state.recordsRequest = {
        page: payload.page,
        last: payload.last
      }
    },
    setRecords: (state, { payload }) => {
      state.records = payload;
    },
    addRecords: (state, { payload }) => {
      state.records = [...state.records, ...payload];
    },
    setFailedImgHistoryCsvDownload: (state, {payload}) => {
        state.downloadCsv = payload;
    },
    setTableInfo: (state, { payload }) => {
      state.tableInfo = payload;
  }
  }
});

export const {
  requestStarted,
  requestSucceed,
  requestFailed,
  resetErrors,
  setRecordsRequest,
  setRecords,
  addRecords,
  setFailedImgHistoryCsvDownload,
  setTableInfo
} = failedImageLogsSlice.actions;

export const failedImageLogsSelector = (state: IState) => state.failedImageLogs;

export const getFailedImageLogs = (
  filter: FailedImageLogsFilterModel,
  page: number
): AppThunk => async (dispatch) => {
  dispatch(requestStarted(page ? "GET_RECORDS_PORTION" : "GET_RECORDS"));
  const response = await failedImageLogsService.getFailedImageLogsRecords(filter, page);
  if (response.isCancel?.()) return;
  if (response.ok()) {
    dispatch(setRecordsRequest({
      page: response.data?.page,
      last: response.data?.totalPages
    }));
    dispatch(page ? addRecords(Object.values(response.data.orderedFailedImagesHistory).flat()) : setRecords(Object.values(response.data.orderedFailedImagesHistory).flat()));
    dispatch(requestSucceed());
  } else {
    dispatch(requestFailed(response.getError ? response.getError() : "Error"));
  }
};
export const updateFailedImgHistoryCsvDownload = (downloadCsv: boolean): AppThunk => (dispatch) => {
    dispatch(setFailedImgHistoryCsvDownload(downloadCsv));
};

export const getFailedImageHistoryTableInfo = (): AppThunk => async (dispatch) => {
    const response = await failedImageLogsService.getFailedImageHistoryTableInfo();
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(setTableInfo(response.data));
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
};
const failedImageLogsReducer = failedImageLogsSlice.reducer;
export default failedImageLogsReducer;
